export enum TuffexProductInventoryWorkspaceCapabilityAccessOperation {
    create = "63b19352-aa7b-4f7f-b263-7791dece6cf2",
    read = "f5a38269-f9fc-4ada-b799-84b24fe232ad",
    update = "63706df3-e955-452d-9fcc-4c814e7cee43",
    delete = "52b4c8c7-d5c1-4390-a374-39e6e15cd40a",
}
